import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetVirtualTourAnnotationsQuery = (tourId: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["virtual-tour-annotations", tourId],
    enabled: !!tourId,
    queryFn: async () => {
      const { data } = await authApi.get<Array<VirtualTourAnnotation>>(
        `/virtual-tour/annotations/${tourId}`
      );
      return data;
    },
  });

  return result;
};
